<!DOCTYPE html>

    <!-- <header> -->
    <!-- <div class="m-4"> -->
    <nav class="navbar sticky-top navbar-expand-lg navbar-dark bg-dark">
      <div class="container-fluid">
        <a routerLink="/home" class="navbar-brand">
          <img src="../../assets/images/logo/Tinytoy-logo.jpg" height="28" alt="Tinytoy">
        </a>
        <button type="button" class="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarCollapse">
          <div class="navbar-nav ms-auto">
            <a routerLink="/home" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
              routerLinkActive="active" class="nav-item nav-link">Home</a>
            <a routerLink="/products" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
              routerLinkActive="active" class="nav-item nav-link">Our
              Products</a>
            <a routerLink="/about-us" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
              routerLinkActive="active" class="nav-item nav-link">About Us</a>
            <a routerLink="/contact-us" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
              routerLinkActive="active" class="nav-item nav-link">Contact Us</a>
          </div>
        </div>
      </div>
    </nav>
    <!-- </div> -->
    <!-- </header> -->
